module.exports = __webpack_public_path__ + "static/media/table-overview-map.9bcf3622.svg";